const splitPascalCase = (value: string) => value.split(/(?=[A-Z])/).join(' ');

const capitalizeWords = (value: string, separator = ' ') =>
  value
    .split(separator)
    .map((word) => {
      const firstLetter = word.charAt(0).toUpperCase();
      return firstLetter + word.slice(1);
    })
    .join(' ');

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export { splitPascalCase, capitalizeWords, capitalize };

export function removeNonAlphanumeric(str: string) {
  return str.replace(/[^a-zA-Z0-9]/g, '');
}
